import React from "react";
import { ConfigProvider as AntdConfigProvider, theme as antdTheme } from "antd";
import type { ConfigProviderProps as AntdConfigProviderProps } from "antd";

export type ConfigProviderProps = AntdConfigProviderProps;

/**
 * ConfigProvider component - provides global configuration for all components
 */
const ConfigProvider: React.FC<ConfigProviderProps> = (props) => {
  return <AntdConfigProvider {...props} />;
};

/**
 * Theme algorithms and utilities from Ant Design
 */
export const theme = antdTheme;

/**
 * Re-export en_US locale for use with ConfigProvider
 * Usage: import { locale, ConfigProvider } from "@version2/ui-package";
 *        <ConfigProvider locale={locale}>...</ConfigProvider>
 * 
 * Note: Currently only en_US is exported. For other locales, import directly from antd:
 *       import esES from "antd/lib/locale/es_ES";
 */
export { default as locale } from "antd/lib/locale/en_US";

export default ConfigProvider;
